export default __webpack_public_path__ + "static/media/mail.ba8e1a07.svg";